import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import ActionModal from '@shared/components/Modals/ActionModal.js';
import { ChatProvider } from '@shared/contexts/ChatContext';
import { SnackbarServiceProvider } from '@shared/services/SnackbarService/SnackbarServiceContext.js';
import { GlobalStyles } from '@shared/styles';
import { theme } from '@shared/theme/index.js';
import { PostHogProvider } from 'posthog-js/react';
// import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import MessageModal from '@/shared/components/Modals/MessageModal.js';
import { UserProvider } from '@/shared/contexts/UserContext';
import { MessageServiceProvider } from '@/shared/services/MessageService/MessageServiceContext.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReviewProvider from './scenes/review/context/ReviewContext';
import './index.css';
import './third-party/sentry.js';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_PRO_KEY || '');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const postHogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <BrowserRouter>
          <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={postHogOptions}>
            <UserProvider>
              <MessageServiceProvider>
                <SnackbarServiceProvider>
                  <ChatProvider>
                    <ReviewProvider>
                      <MessageModal />
                      <ActionModal />
                      <App />
                    </ReviewProvider>
                  </ChatProvider>
                </SnackbarServiceProvider>
              </MessageServiceProvider>
            </UserProvider>
          </PostHogProvider>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
